console.log("%c LUXURY SIZE FINDER SCRIPT - MEASUREMENTS ONLY LOADED ", "background:#0a0; color:#fff; font-size:16px; padding:4px;");

function updateRecommendedSizeLabel(size) {
  const label = document.getElementById("recommended-size");
  if (!label) return;

  const text = String(size ?? "").trim();
  label.textContent = text;
  label.dataset.sizeLength = String(text.length);
}

 
function showScreen(step){
  document.querySelectorAll(".lsf-screen").forEach(screen=>{
    screen.classList.remove("active");
  });
  const target=document.querySelector(`.lsf-screen[data-screen="${step}"]`);
  if(target){
    target.classList.add("active");
  }
  currentStep=step;
  updateProgress();
  window.scrollTo({ top:0, behavior:"smooth" });
}
 
function updateProgress(){
  const displayStep = currentStep === "3-loading" ? 3 : currentStep;
  document.querySelectorAll(".lsf-step").forEach(step=>{
    step.classList.remove("active","completed");
    const number=parseInt(step.dataset.step);
    if(number<displayStep){
      step.classList.add("completed");
    }
    else if(number===displayStep){
      step.classList.add("active");
    }
  });
  document.querySelector(".lsf-progress").className=`lsf-progress step-${displayStep}`;
}
 
let currentStep = 1;
 
 
 
const EASE_ALLOWANCE = {
  "t-shirt": { neck: 1, chest: 2, length: 0 },
  "raincoat": { neck: 1, chest: 2, length: 0 },
  "jacket": { neck: 1, chest: 2, length: 0 },
  "harness": { neck: 1, chest: 2, length: 0 },
  "bow": { neck: 0.5, chest: 0, length: 0 },
  "bandana": { neck: 0.5, chest: 0, length: 0 },
  // aap jitne products hain sab add kar sakte hain
  "default": { neck: 1, chest: 2, length: 0 }  // fallback agar koi naya product mile
};
 
/*==========================================
PRODUCT WISE REQUIRED "MEASUREMENT" FIELDS
Only the product-specific measurements listed below are required.
 
Harness  -> neck + chest
Bow      -> neck
Bandana  -> neck
baaki sab (t-shirt, raincoat, jacket, default) -> neck + chest + length
==========================================*/
const PRODUCT_FIELDS = {
  "harness": ["neck", "chest"],
  "bow": ["neck"],
  "bandana": ["neck"],
  "default": ["neck", "chest", "length"]
};
 
/*==========================================
GENERIC RANGE PARSER (neck / chest / length)
Metaobject/reference value "11-14" / "11 to 14 inches" / sirf "12" —
kisi bhi format me ho sakti hai. Yeh { min, max } return karta hai.
==========================================*/
function parseRange(rawValue){
  if(rawValue === null || rawValue === undefined || rawValue === "") return null;
 
  const numbers = String(rawValue).match(/[\d.]+/g);
 
  if(!numbers || !numbers.length) return null;
 
  if(numbers.length === 1){
    const single = parseFloat(numbers[0]);
    return { min: single, max: single };
  }
 
  const a = parseFloat(numbers[0]);
  const b = parseFloat(numbers[1]);
 
  return { min: Math.min(a,b), max: Math.max(a,b) };
}
 
// User ki value chart wali range ke andar ho to diff = 0,
// warna range ke sabse nazdeek edge se diff nikalta hai.
function rangeDiff(rawChartValue, userValue){
  const range = parseRange(rawChartValue);
  if(!range) return Math.abs(Number(rawChartValue) - userValue);
  if(userValue >= range.min && userValue <= range.max) return 0;
  if(userValue < range.min) return range.min - userValue;
  return userValue - range.max;
}
 
function getRequiredFields(productKey){
  const key = (productKey || "").toLowerCase();
  if(key.includes("harness")) return PRODUCT_FIELDS["harness"];
  if(key.includes("bow")) return PRODUCT_FIELDS["bow"];
  if(key.includes("bandana")) return PRODUCT_FIELDS["bandana"];
  return PRODUCT_FIELDS["default"];
}
 
function getEaseAllowance(productKey){
  const key = (productKey || "").toLowerCase();
  if(key.includes("harness")) return EASE_ALLOWANCE["harness"];
  if(key.includes("bow")) return EASE_ALLOWANCE["bow"];
  if(key.includes("bandana")) return EASE_ALLOWANCE["bandana"];
  if(key.includes("t-shirt") || key.includes("tshirt")) return EASE_ALLOWANCE["t-shirt"];
  if(key.includes("raincoat")) return EASE_ALLOWANCE["raincoat"];
  if(key.includes("jacket")) return EASE_ALLOWANCE["jacket"];
  return EASE_ALLOWANCE["default"];
}
 
const userData = {
  product: "",
  mode: "measurement",
  neck: 0,
  chest: 0,
  length: 0,
  finalNeck: 0,
  finalChest: 0,
  finalLength: 0,
  size: ""
};
 
document.addEventListener("DOMContentLoaded", () => {
 
  /*==========================================
  NEXT BUTTON
  ==========================================*/
  document.querySelectorAll(".next-step").forEach(button=>{
    button.addEventListener("click",function(){
      const next=parseInt(this.dataset.next);
 
      // Step 2 ka next — product select check
      if(currentStep === 2 && !userData.product){
        alert("Please select a product first.");
        return;
      }
 
      showScreen(next);
    });
  });
 
  /*==========================================
  BACK BUTTON
  ==========================================*/
  document.querySelectorAll(".back-step").forEach(button=>{
    button.addEventListener("click",function(){
      const prev=parseInt(this.dataset.prev);
      showScreen(prev);
    });
  });
 
  /*==========================================
  RESTART
  ==========================================*/
  const restartBtn = document.querySelector(".restart-finder");
  if(restartBtn){
    restartBtn.addEventListener("click",()=>{
      location.reload();
    });
  }
 
  /*==========================================
  PRODUCT SELECT
  ==========================================*/
  const products = document.querySelectorAll(".lsf-product");
  const productNextBtn = document.querySelector('.lsf-screen[data-screen="2"] .next-step');
 
  // Pehle disabled rakho
  if(productNextBtn){
    productNextBtn.disabled = true;
    productNextBtn.style.opacity = "0.5";
    productNextBtn.style.cursor = "not-allowed";
  }
 
  // Measurement fields product ke hisaab se show/hide honge.
  function toggleMeasurementFields(productKey){
    const requiredFields = getRequiredFields(productKey);
 
    const neckInput = document.getElementById("lsf-neck");
    const chestInput = document.getElementById("lsf-chest");
    const lengthInput = document.getElementById("lsf-length");
 
    const fieldWrapperMap = {
      neck: neckInput?.closest(".lsf-measure-card"),
      chest: chestInput?.closest(".lsf-measure-card"),
      length: lengthInput?.closest(".lsf-measure-card")
    };
 
    Object.keys(fieldWrapperMap).forEach(field=>{
      const wrapper = fieldWrapperMap[field];
      if(!wrapper){
        return;
      }
      if(requiredFields.includes(field)){
        wrapper.style.removeProperty("display");
      } else {
        wrapper.style.setProperty("display", "none", "important");
      }
    });
  }
 
  products.forEach(card=>{
    card.addEventListener("click",()=>{
      products.forEach(item=>item.classList.remove("active"));
      card.classList.add("active");
      userData.product = card.dataset.product;
 
      // Product ke hisaab se measurement fields show/hide karo
      toggleMeasurementFields(userData.product.trim().toLowerCase());
 
      // Product select hone ke baad Next enable karo
      if(productNextBtn){
        productNextBtn.disabled = false;
        productNextBtn.style.opacity = "1";
        productNextBtn.style.cursor = "pointer";
      }
    });
  });
 
  /*==========================================
  CALCULATE SIZE BUTTON — MEASUREMENTS ONLY
  ==========================================*/
  const calculateBtn = document.getElementById("calculate-size");
  if (calculateBtn) {
    calculateBtn.addEventListener("click", () => {
      const productKey = userData.product.trim().toLowerCase();
      const measureFields = getRequiredFields(productKey);

      const values = {
        neck: parseFloat(document.getElementById("lsf-neck").value),
        chest: parseFloat(document.getElementById("lsf-chest").value),
        length: parseFloat(document.getElementById("lsf-length").value)
      };
      const isFilled = value => Number.isFinite(value) && value > 0;
      const missingFields = measureFields.filter(field => !isFilled(values[field]));

      if (missingFields.length) {
        alert(`Please enter valid ${missingFields.join(", ")} measurement(s) in inches.`);
        const firstMissingInput = document.getElementById(`lsf-${missingFields[0]}`);
        if (firstMissingInput) firstMissingInput.focus();
        return;
      }

      userData.mode = "measurement";
      const ease = getEaseAllowance(productKey);

      userData.neck = measureFields.includes("neck") ? values.neck : 0;
      userData.chest = measureFields.includes("chest") ? values.chest : 0;
      userData.length = measureFields.includes("length") ? values.length : 0;

      userData.finalNeck = measureFields.includes("neck") ? values.neck + ease.neck : 0;
      userData.finalChest = measureFields.includes("chest") ? values.chest + ease.chest : 0;
      userData.finalLength = measureFields.includes("length") ? values.length + ease.length : 0;

      document.getElementById("final-neck").value = userData.finalNeck;
      document.getElementById("final-chest").value = userData.finalChest;
      document.getElementById("final-length").value = userData.finalLength;

      showScreen("3-loading");
      setTimeout(() => {
        calculateSize();
        showResult();
      }, 2000);
    });
  }

  /*==========================================
  DRAWER
  ==========================================*/
  const drawer = document.querySelector(".lsf-drawer");
  const drawerBtn = document.querySelector(".lsf-view-details");
  const drawerClose = document.querySelector(".drawer-close");
  const drawerOverlay = document.querySelector(".lsf-drawer-overlay");
 
  if(drawerBtn){
    drawerBtn.addEventListener("click",()=>{
      drawer.classList.add("active");
      document.body.style.overflow="hidden";
    });
  }
 
  function closeDrawer(){
    drawer.classList.remove("active");
    document.body.style.overflow="";
  }
 
  if(drawerClose){
    drawerClose.addEventListener("click",closeDrawer);
  }
  if(drawerOverlay){
    drawerOverlay.addEventListener("click",closeDrawer);
  }
 
  document.addEventListener("keydown",(e)=>{
    if(e.key==="Escape"){
      closeDrawer();
    }
  });
 
  /*==========================================
  ADD TO CART
  ==========================================*/
  const addBtn=document.querySelector(".add-size-product");
  if(addBtn){
    addBtn.addEventListener("click",function(){
      const variant=this.dataset.variant;
      if(!variant){
        alert("Variant ID not found.");
        return;
      }
      this.disabled=true;
      this.innerHTML="Adding...";
 
      const productKey = userData.product.trim().toLowerCase();
      const measureFields = getRequiredFields(productKey);
 
      const properties = {
        "Recommended Size": userData.size,
        "Age": userData.age,
        "Product Type": userData.product,
        "Sized By": "Measurement"
      };

      if (measureFields.includes("neck")) properties["Adjusted Neck"] = userData.finalNeck + " Inches";
      if (measureFields.includes("chest")) properties["Adjusted Chest"] = userData.finalChest + " Inches";
      if (measureFields.includes("length")) properties["Body Length"] = userData.finalLength + " Inches";

      fetch("/cart/add.js",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          id:Number(variant),
          quantity:1,
          properties: properties
        })
      })
      .then(r=>r.json())
      .then(()=>{
        this.innerHTML="✓ Added";
        setTimeout(()=>{
          window.location="/cart";
        },700);
      })
      .catch(()=>{
        alert("Unable to add product.");
        this.disabled=false;
        this.innerHTML="Add To Cart";
      });
    });
  }
 
  /*==========================================
  INIT
  ==========================================*/
  showScreen(1);
  window.SizeFinder=userData;
 
});
 
/*==========================================
SIZE LOGIC — product-specific measurements only
==========================================*/
function calculateSize(){
  const productKey = userData.product.trim().toLowerCase();
  const measureFields = getRequiredFields(productKey);
 
  // Ek hi entry ka "Product Type" field multiple products ke liye kaam kar
  // sakta hai — metaobject me comma se separate karke likh do,
  // jaise: "Harness, Vest, Raincoat".
  const chart = window.SIZE_CHART.filter(item=>{
    const types = item.product_type.split(",").map(t=>t.trim().toLowerCase());
    return types.includes(productKey);
  });
 
  if(!chart.length){
    userData.size = "N/A";
    userData.match = 0;
    userData.fit = "No size chart found for this product.";
    document.getElementById("final-size").value = userData.size;
    return;
  }
 
  let bestMatch = null;
  let bestScore = Infinity;
 

  const neck   = Number(userData.finalNeck);
  const chest  = Number(userData.finalChest);
  const length = Number(userData.finalLength);

  chart.forEach(item=>{

    let neckDiff = 0, chestDiff = 0, lengthDiff = 0;
    let rejected = false;

    if(measureFields.includes("neck")){
      neckDiff = rangeDiff(item.neck, neck);
      if(neckDiff > 2) rejected = true;
    }

    if(measureFields.includes("chest")){
      chestDiff = rangeDiff(item.chest, chest);
      if(chestDiff > 3) rejected = true;
    }

    if(measureFields.includes("length")){
      lengthDiff = rangeDiff(item.length, length);
      if(lengthDiff > 2) rejected = true;
    }

    if(rejected) return;

    let score;
    if(measureFields.length === 3){
      // t-shirt, raincoat, jacket, default -> neck+chest+length
      score = chestDiff*0.5 + neckDiff*0.3 + lengthDiff*0.2;
    } else if(measureFields.includes("chest")){
      // harness -> neck+chest
      score = chestDiff*0.6 + neckDiff*0.4;
    } else {
      // bow, bandana -> neck only
      score = neckDiff;
    }

    if(score < bestScore){
      bestScore = score;
      bestMatch = item;
    }

  });

  if(!bestMatch){
 
    userData.size = "NA";
    userData.match = 0;
    userData.fit = "Outside our size chart. Need Customization.";
 
    document.getElementById("final-size").value = userData.size;
 
    return;
 
  }
 
  userData.size = bestMatch.size;
 
  // Every 1 unit difference = -2% (min 80%)
  userData.match = Math.max(
    80,
    Math.round(100 - (bestScore * 2))
  );
 
  if (userData.match >= 98) {
    userData.fit = "⭐⭐⭐⭐⭐ Perfect Fit";
  } else if (userData.match >= 95) {
    userData.fit = "✅ Excellent Fit";
  } else if (userData.match >= 90) {
    userData.fit = "👍 Great Fit";
  } else if (userData.match >= 85) {
    userData.fit = "🙂 Good Fit";
  } else if (userData.match >= 80) {
    userData.fit = "⚠️ Comfortable Fit";
  } else {
    userData.fit = "❗ Consider One Size Up/Down";
  }
 
  updateRecommendedSizeLabel(userData.size);
 
  const fitStatus = document.getElementById("fit-status");
 
  if(fitStatus){
    fitStatus.textContent = userData.fit;
  }
 
  document.getElementById("final-size").value = userData.size;
 
  const match = document.getElementById("fit-score");
  if(match){
    match.textContent = userData.match + "%";
  }
}
 
/*==========================================
SHOW RESULT — measurement values only
==========================================*/
function showResult(){
  showScreen(4);
 
  const productKey = userData.product.trim().toLowerCase();
  const measureFields = getRequiredFields(productKey);
 
  updateRecommendedSizeLabel(userData.size);
 
  document.querySelectorAll(".result-neck").forEach(el=>{
    const row = el.parentElement;
    if(measureFields.includes("neck")){
      el.textContent=userData.finalNeck+" Inches";
      if(row){ row.style.display = ""; }
    } else {
      if(row){ row.style.display = "none"; }
    }
  });
 
  document.querySelectorAll(".result-chest").forEach(el=>{
    const row = el.parentElement;
    if(measureFields.includes("chest")){
      el.textContent=userData.finalChest+" Inches";
      if(row){ row.style.display = ""; }
    } else {
      if(row){ row.style.display = "none"; }
    }
  });
 
  document.querySelectorAll(".result-length").forEach(el=>{
    const row = el.parentElement;
    if(measureFields.includes("length")){
      el.textContent=userData.finalLength+" Inches";
      if(row){ row.style.display = ""; }
    } else {
      if(row){ row.style.display = "none"; }
    }
  });
 
  document.getElementById("fit-score").textContent =
    userData.match + "% Match";
 
  document.getElementById("fit-status").textContent =
    userData.fit;
 
  const noteNeck = document.querySelector(".note-neck");
  const noteChest = document.querySelector(".note-chest");

  if (noteNeck) noteNeck.style.display = measureFields.includes("neck") ? "" : "none";
  if (noteChest) noteChest.style.display = measureFields.includes("chest") ? "" : "none";
}
 
window.SizeFinder = userData;